// Layout.jsx - AVEC CONTRÔLES D'ANIMATIONS
import React, { useEffect, useState } from "react";
import Loader from "./loader.gif";
import elakay_logo_loading from "./imgs/elakay_loading3.gif";
import Sidebar from "./Sidebar";
import AddToDeal from "../Dwawer/addTodeal";
import SliderPun135 from "../slider/swiperPub1500x400";
import CategoryAdBanner from "../dynamicSwipers/CategoryAdBanner";
import Footer from "./Footer";
import './elakay_index.css';
import { elakayAutoText } from "../pageInside/dataElakay";
import { buildGradientOrSolidBackground } from "../../config";
import { buildLayoutBodyBackgroundPresentation, resolveLayoutBodyBackground } from "../../utils/appearanceSettings";
import FamilyErrorDiagnostics from "./FamilyErrorDiagnostics";
import FloatingEmailInboxIcon from "./FloatingEmailInboxIcon";
import DropshippingPasswordConfirmationModal from "../pageInside/DropshippingPasswordConfirmationModal";
import { CJPasswordConfirmationProvider } from "../pageInside/sync/CJPasswordConfirmationContext";
import { Link, useLocation } from "react-router-dom";
import { MdDeleteForever } from "react-icons/md";


const ELAKAY_BRAND_TITLE = "Elakay";

const ELAKAY_TITLE_FALLBACKS = {
  logo: "Logo",
  home: "Home",
  signin: "Sign in",
  signup: "Create account",
  active: "Account activation",
  forgetPassword: "Forgot password",
  password: "Reset password",
  userPub: "Shared home",
  productPreview: "Product preview",
  newProduct: "New products",
  bestSellers: "Best sellers",
  productCatalog: "Product catalog",
  search: "Search",
  allCategories: "All categories",
  helpContact: "Help and contact",
  dealToday: "Today's deals",
  investments: "Investments",
  investmentDetail: "Investment detail",
  jobs: "Jobs",
  jobDetail: "Job detail",
  howToStep: "How to start",
  shopSeller: "Shop",
  shopAbout: "About the shop",
  errorPage: "Page not found",
  yourStep: "Your steps",
  cart: "Cart",
  userViewed: "Viewed products",
  searchHistoryAllCards: "Search history",
  viewingActivityAllCards: "Viewing activity",
  shopsYouFollowAllCards: "Shops you follow",
  profile: "Profile",
  orders: "Orders",
  account: "Account",
  purchased: "Purchases",
  get message() { return elakayAutoText("h_f1702b4686278b", "Messages"); },
  myJobApplications: "My job applications",
  wallet: "Wallet",
  userSetting: "Settings",
  myShop: "My shop",
  editProduct: "Edit product",
  delivery: "Delivery",
  postman: "Delivery agent",
  userChoosing: "Choose role",
  addUsers: "Add users",
  adminAssociate: "Associate administration",
  languageAdmin: "Languages",
  pageBuilder: "Page builder",
  investmentDashboard: "Investment dashboard",
  jobDashboard: "Job dashboard",
  jobPositions: "Job positions",
  jobApplications: "Job applications",
  animationSettings: "Animation settings",
  traductorTeam: "Translation team",
  category: "Category",
  filters: "Filters",
  filterItems: "Filter items",
  categoryFilters: "Category filters",
  linkCategory: "Link categories",
  categoryFilterValues: "Category filter values"
};

const cleanTitleValue = (value) => (
  typeof value === "string" ? value.trim() : ""
);

const humanizeTitleKey = (key) => cleanTitleValue(key)
  .replace(/([a-z])([A-Z])/g, "$1 $2")
  .replace(/[-_]+/g, " ")
  .replace(/\s+/g, " ")
  .replace(/\b\w/g, (letter) => letter.toUpperCase());

const getLanguageCode = (infoSource) => (
  infoSource?.languageAPI?.obj?.code
  || infoSource?.languageAPI?.language
  || infoSource?.languageAPI?.code
  || "en"
);

const readLanguageTitle = (infoSource, group, key) => {
  if (!infoSource || !key) return "";

  try {
    const value = infoSource.language?.(infoSource, group, key);
    const title = cleanTitleValue(value);
    if (title) return title;
  } catch {
    // Some language groups can be absent while the API language is loading.
  }

  try {
    const groupValue = infoSource.laguangeElakay?.(group, infoSource.languageAPI);
    const title = cleanTitleValue(groupValue?.[key]);
    if (title) return title;
  } catch {
    // Keep a stable browser title even if a custom translation is missing.
  }

  return "";
};

export const resolveElakayTitleText = (infoSource, titleElakay = "home") => {
  if (typeof titleElakay === "function") {
    try {
      const title = cleanTitleValue(titleElakay(infoSource));
      if (title) return title;
    } catch {
      return ELAKAY_BRAND_TITLE;
    }
  }

  if (titleElakay && typeof titleElakay === "object" && !Array.isArray(titleElakay)) {
    const langCode = getLanguageCode(infoSource);
    const title = cleanTitleValue(
      titleElakay[langCode]
      || titleElakay.default
      || titleElakay.en
    );

    if (title) return title;
  }

  const titleKey = cleanTitleValue(titleElakay) || "home";

  const translatedTitle = (
    readLanguageTitle(infoSource, "titleElakay", titleKey)
    || readLanguageTitle(infoSource, "pageTitle", titleKey)
    || readLanguageTitle(infoSource, "title", titleKey)
  );

  if (translatedTitle) return translatedTitle;

  return ELAKAY_TITLE_FALLBACKS[titleKey] || humanizeTitleKey(titleKey) || ELAKAY_BRAND_TITLE;
};

export const buildElakayDocumentTitle = (infoSource, titleElakay = "home") => {
  const pageTitle = resolveElakayTitleText(infoSource, titleElakay);

  if (!pageTitle || pageTitle.toLowerCase() === ELAKAY_BRAND_TITLE.toLowerCase()) {
    return ELAKAY_BRAND_TITLE;
  }

  if (pageTitle.toLowerCase().includes(ELAKAY_BRAND_TITLE.toLowerCase())) {
    return pageTitle;
  }

  return `${pageTitle} | ${ELAKAY_BRAND_TITLE}`;
};

export const setElakayDocumentTitle = (infoSource, titleElakay = "home") => {
  if (typeof document === "undefined") return "";

  const nextTitle = buildElakayDocumentTitle(infoSource, titleElakay);
  document.title = nextTitle;

  const titleNode = document.getElementById("titleElakay");
  if (titleNode) {
    titleNode.textContent = nextTitle;
  }

  return nextTitle;
};

export const useElakayDocumentTitle = (infoSource, titleElakay = "home", enabled = true) => {
  useEffect(() => {
    if (!enabled) return undefined;

    setElakayDocumentTitle(infoSource, titleElakay);
    return undefined;
  }, [enabled, infoSource, infoSource?.languageAPI, titleElakay]);
};

const Layout = (props) => {
  const routeLocation = useLocation();
  const isUserProductPage = routeLocation.pathname.toLowerCase() === "/myshop";
  // A page starts its data request in an effect: on its very first frame
  // `loading` is still false and the content empty, so the Footer showed in
  // the screen for an instant, then jumped below the loading view. That first
  // frame keeps the loading height (.elakay-page-body-area.is-loading).
  const [firstFrame, setFirstFrame] = useState(true);
  useEffect(() => {
    const frame = requestAnimationFrame(() => setFirstFrame(false));
    return () => cancelAnimationFrame(frame);
  }, []);
  const {
    infoSource,
    title,
    titleElakay,
    loading,
    children,
    SliderPunShow,
    ShowSideDeal,
    getFilterUserProd,
    myFilters,
    productaddToDeal,
    loadProductsByArrival,
    setShowSideDeal,
    skip,
    limit,
    DealProduct,
    P1,
    categoriesID,
    pubCategoryId,
    swiperOptions,
    handleFilters,
    prices,
    setMyFilters,
    AllCategorie,
    getpub,
    filterShop = false,
    setFilterShop,
    userShop = false,
    propsFIlter,
    inpage,
    getCalFilShop,
    infoHeaderShop,
    allHeaderShop,
    outOffPage,
    showFilterMenu = true,
    showFooter = true,
    subnavMessages,
    subnavCategoryTitles,
    subnavPreviousCategoryTitle,
    subnavPreviousCategoryLink,
    // Animation controls for Layout
    enableBodyParticles = false,
    enableFloatingSquares = false,
    enableContentFadeIn = false,
    particlesCount = 0,
    squaresCount = 0,
    particlesColor = '#007399',
    squaresColor = '#4facfe',
    backgroundColor = null,
    backgroundColorSecondary = null,
    layoutBackground = null,
    layoutBodyBackground = null,
    pageTopRef = null,
  } = props;

  // Pendant le chargement (laadingGIf), le fond reste blanc quelle que soit
  // la couleur/dégradé configurée dans AnimationSettings. Sinon : une seule
  // couleur renseignée => fond uni (pas de dégradé forcé avec une 2e couleur
  // par défaut) ; aucune => le dégradé CSS d'origine (.elakay-page-body-area)
  // s'applique. Ce fond + son box-model (padding/border/shadow/...) ne
  // s'appliquent JAMAIS au Header ni au Footer : voir le rendu plus bas,
  // .elakay-page-body-area n'enveloppe que le contenu, pas Sidebar/Header/Footer.
  const resolvedBodyBackground = layoutBodyBackground
    || resolveLayoutBodyBackground(
      layoutBackground
        ? { layoutBackground }
        : (infoSource?.allSettings || {})
    );
  const advancedBackground = buildLayoutBodyBackgroundPresentation(resolvedBodyBackground);
  const bodyAreaStyle = loading
    ? { background: '#ffffff' }
    : {
      ...(advancedBackground?.rootStyle
        || buildGradientOrSolidBackground(backgroundColor, backgroundColorSecondary, 135)),
      ...advancedBackground?.containerStyle,
    };
  const hasCustomBodyBackground = !loading && Boolean(
    advancedBackground?.imageStyle || advancedBackground?.gradientStyle || advancedBackground?.overlayStyle
  );

  const layoutTitle = titleElakay || (typeof title === "string" ? title : undefined);
  useElakayDocumentTitle(infoSource, layoutTitle, Boolean(layoutTitle));

  const laadingGIf = () => (
 <div className="page-container loading-page">

  <div className="square-wrapper">
  <img
    src={elakay_logo_loading}
    className={`search-loading ${loading ? "show" : "hide"}`}
    alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).layout.t001}
  />
  </div>  
  <h2 className="text-center">
    {infoSource.language(infoSource, "title", "loanding")}
  </h2>
</div>
  );

  const buttonDealB = () => {
    if (setShowSideDeal) setShowSideDeal(!ShowSideDeal);
  };

  const showLayout = (
    <div className={`elakayPage ${!enableContentFadeIn ? 'no-fade' : ''}`}>
      <DropshippingPasswordConfirmationModal />

      {/* ========================================
          ✨ PARTICULES MONTANTES DYNAMIQUES ✨
          Du pied de page jusqu'en bas du header
          ======================================== */}
      {enableBodyParticles && (
        <div className="body-particles">
          {[...Array(particlesCount)].map((_, i) => (
            <div
              key={i}
              className="body-particle"
              style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
                animationDuration: `${3 + Math.random() * 2}s`
              }}
            ></div>
          ))}
        </div>
      )}

      {/* ========================================
          🔷 CARRÉS FLOTTANTS 🔷
          8 carrés qui flottent et tournent
          ======================================== */}
      {enableFloatingSquares && (
        <div className="floating-squares">
          {[...Array(squaresCount)].map((_, i) => (
            <div key={i} className="floating-square"></div>
          ))}
        </div>
      )}
      {/* ========================================
          📦 SIDEBAR (Header inclus) — jamais stylé par le fond du body
          ======================================== */}
      <div className="elakay-layout-foreground elakay-layout-header">
      <Sidebar
        infoSource={infoSource}
        SliderPunShow={SliderPunShow}
        categoriesID={categoriesID}
        handleFilters={handleFilters}
        prices={prices}
        setMyFilters={setMyFilters}
        AllCategorie={AllCategorie}
        filterShop={filterShop}
        setFilterShop={setFilterShop}
        outOffPage={outOffPage}
        userShop={userShop}
        getCalFilShop={getCalFilShop}
        infoHeaderShop={infoHeaderShop}
        allHeaderShop={allHeaderShop}
        inpage={inpage}
        propsFIlter={propsFIlter}
        showFilterMenu={showFilterMenu}
        pageTopRef={pageTopRef}
        subnavMessages={subnavMessages}
        subnavCategoryTitles={subnavCategoryTitles}
        subnavPreviousCategoryTitle={subnavPreviousCategoryTitle}
        subnavPreviousCategoryLink={subnavPreviousCategoryLink}
      />
      </div>

      {/* ========================================
          📦 ZONE DE CONTENU CENTRALE (Layout & Body Background)
          Seul le contenu entre Header et Footer reçoit le fond/box-model
          configurés dans AnimationSettings ("Layout & Body Background").
          ======================================== */}
      <div
        className={`elakay-page-body-area ${hasCustomBodyBackground ? 'has-custom-background' : ''}${loading || firstFrame ? ' is-loading' : ''}`}
        style={bodyAreaStyle}
      >
        {hasCustomBodyBackground && advancedBackground?.imageStyle && (
          <div className="elakay-background-layer elakay-background-image" style={advancedBackground.imageStyle} aria-hidden="true" />
        )}
        {hasCustomBodyBackground && advancedBackground?.gradientStyle && (
          <div className="elakay-background-layer elakay-background-gradient" style={advancedBackground.gradientStyle} aria-hidden="true" />
        )}
        {hasCustomBodyBackground && advancedBackground?.overlayStyle && (
          <div className="elakay-background-layer elakay-background-overlay" style={advancedBackground.overlayStyle} aria-hidden="true" />
        )}

      {loading ? (
        laadingGIf()
      ) : (
        <>
          <div className="page-container">
            {/* Slider pub en haut */}
            {/* My Global Pub: an Elakay Swiper chosen for the category replaces
                its image slider (kept as is otherwise). pubCategoryId = the
                category whose pub is shown (Home: the root category). */}
            {!userShop && SliderPunShow && (
              <CategoryAdBanner categoryId={pubCategoryId || categoriesID} ownImages={getpub} swiperOptions={swiperOptions}>
                <SliderPun135
                  infoSource={infoSource}
                  categoriesID={categoriesID}
                  SliderPunShow={SliderPunShow}
                  swiperOptions={swiperOptions}
                  getpub={getpub}
                  P1={P1}
                />
              </CategoryAdBanner>
            )}

            {/* Contenu des pages */}
            <div className={`content-wrap ${!enableContentFadeIn ? 'no-animation' : ''}`}>
              {children}
            </div>

            {/* Drawer AddToDeal */}
            {productaddToDeal && ShowSideDeal && (
              <AddToDeal
                infoSource={infoSource}
                show={ShowSideDeal}
                buttonDealB={buttonDealB}
                productaddToDeal={productaddToDeal}
                myFilters={myFilters}
                loadProductsByArrival={loadProductsByArrival}
                getFilterUserProd={getFilterUserProd}
                skip={skip}
                limit={limit}
                DealProduct={DealProduct}
              />
            )}
          </div>
        </>
      )}
      </div>
{/* {...props} */}
      {/* ========================================
          🎨 FOOTER — jamais stylé par le fond du body
          ======================================== */}
      {showFooter && (
        <div className="elakay-layout-foreground elakay-layout-footer">
        <Footer
          infoSource={infoSource}
          elakayCategories={infoSource.elakayCategories}
          {...infoSource?.allSettings?.footer}
        />
        </div>
      )}
    </div>
  );

  return <CJPasswordConfirmationProvider><div>
    {showLayout}
    {isUserProductPage && infoSource.trashCount > 0 && (
      <Link
        to="/myShop?trash=1"
        className="family-error-button floating-trash-button"
        onClick={() => window.dispatchEvent(new CustomEvent('elakay:open-trash'))}
        title={elakayAutoText("h_nav_trash", "Trash")}
        aria-label={`${elakayAutoText("h_nav_trash", "Trash")} (${infoSource.trashCount})`}
      >
        <MdDeleteForever />
        <span>{infoSource.trashCount}</span>
      </Link>
    )}
    <FamilyErrorDiagnostics infoSource={infoSource} />
    <FloatingEmailInboxIcon infoSource={infoSource} />
    </div></CJPasswordConfirmationProvider>;
};

export default Layout;

/*
================================================================================
UTILISATION DES CONTRÔLES D'ANIMATION
================================================================================

Exemple 1 : Toutes les animations activées (par défaut)
<Layout 
    infoSource={infoSource}
    loading={loading}
>
    {children}
</Layout>

Exemple 2 : Désactiver toutes les animations
<Layout 
    infoSource={infoSource}
    loading={loading}
>
    {children}
</Layout>

Exemple 3 : Garder seulement certaines animations
<Layout 
    infoSource={infoSource}
    loading={loading}
>
    {children}
</Layout>

Exemple 4 : Personnaliser le nombre de particules et carrés
<Layout 
    infoSource={infoSource}
    loading={loading}
    particlesCount={50}    // Plus de particules (défaut: 20)
    squaresCount={12}      // Plus de carrés (défaut: 8)
>
    {children}
</Layout>

================================================================================
CONTRÔLES DISPONIBLES POUR LAYOUT
================================================================================

🎯 Layout Principal:
- enableBodyParticles: true/false → Particules montantes du footer au header
- enableFloatingSquares: true/false → Carrés flottants en arrière-plan
- enableContentFadeIn: true/false → Animation fadeIn du contenu
- particlesCount: number → Nombre de particules (défaut: 20)
- squaresCount: number → Nombre de carrés flottants (défaut: 8)

🎯 Footer (transmis au composant Footer):
- enableFooterAnimations: true/false → Toutes les animations du footer
- enableSectionAnimations: true/false → Animation des sections
- enableItemAnimations: true/false → Animation des items de menu
- enableHoverAnimations: true/false → Effets hover
- enableButtonAnimations: true/false → Animation des boutons
- enableIconAnimations: true/false → Animation des icônes
- enableBackgroundGrid: true/false → Grille de carrés en arrière-plan
- enableGradientOverlay: true/false → Overlay de gradient lumineux
- enableShineEffect: true/false → Effet de brillance
- enableScrollAnimations: true/false → Animations au scroll
- enableStaggeredAnimations: true/false → Animations en cascade
- enableFloatingParticles: true/false → Particules flottantes
- enableRippleEffect: true/false → Effet ripple au clic
- enableTitleAnimations: true/false → Animation des titres
- enableLinkAnimations: true/false → Animation des liens
- enableDividerAnimations: true/false → Animation des séparateurs
- enableCopyrightAnimations: true/false → Animation du copyright

================================================================================
RÉSULTAT VISUEL (AVEC TOUTES LES ANIMATIONS)
================================================================================

                     ┌──────────────────────────────┐
                     │        HEADER (85px)          │
                     └──────────────────────────────┘
                              ↑  ↑  ↑
                              ○  ○  ○  ← Particules s'arrêtent ici
                         ○  ○     ○  ○
     🔷              ○     ○  ○     ○        🔷
                  ○  ○      ○   ○
        🔷      ○     ○  ○      ○
              ○   ○      ○  ○                 🔷
            ○       ○  ○
          ○   ○  ○         BODY
  🔷    ○       ○            ↓                    🔷
      ○   ○               Contenu
    ○       ○             ↓
  ○   ○                   ↓                  🔷
                     ┌──────────────────────────────┐
                     │          FOOTER               │
        🔷           │    (animations stunning)      │    🔷
                     └──────────────────────────────┘
                              ↑
                    Particules commencent ici

Légende:
○ = Particules montantes (si enableBodyParticles = true)
🔷 = Carrés flottants (si enableFloatingSquares = true)

================================================================================
*/
